/*
 *  -----------------------------------------------------------------------
 *    <copyright file="kri-scores-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { useTranslation } from 'hooks';
import { centralMonitoringReviewData_OpraQueries_centralMonitoringReviewData_CentralMonitoringReviewData_riskOverviews_RiskOverviewSite_kriScores_KRIScore as KRIScore } from '@queries/generated/central-monitoring.generated';

import './kri-scores-grid.scss';

const KRIScoresGrid = ({ kriScores }: { kriScores: KRIScore[] }) => {
    const { t } = useTranslation();

    return (
        <table className="kri-scores">
            <tr>
                <th>
                    <p>{t('ra:score')}</p>
                </th>
                {kriScores.map((item: any) => (
                    <th key={item.name}>
                        <p>{item.name}</p>
                    </th>
                ))}
            </tr>
            <tr>
                <td>{t('site')}</td>
                {kriScores.map((item: any) => {
                    const icon =
                        item.change?.toLowerCase() === 'upper'
                            ? 'arrow-circle-up'
                            : item.change?.toLowerCase() === 'lower'
                              ? 'arrow-circle-down'
                              : 'minus-circle';
                    return (
                        <td key={item.panelId}>
                            <span>{item.score > 0 ? item.score.toFixed(2) : '--'}</span>
                            <span> {item.label}</span>
                            <FontAwesomeIcon
                                icon={['far', icon]}
                                className={`arrow-circle ${item.colour?.toLowerCase() || 'black'}`}
                            />
                        </td>
                    );
                })}
            </tr>
            <tr>
                <td className="alt">{t('cm:studyAverage')}</td>
                {kriScores.map((item: any) => (
                    <td key={item.panelId} className="alt">
                        <span>{item.average}</span>
                    </td>
                ))}
            </tr>
        </table>
    );
};

export default KRIScoresGrid;
